export default "__VITE_ASSET__CNJzxKK2__"